/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_WelcomeInputs */

const en_settings_welcome = /** @type {(inputs: Settings_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome back, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Welcome back, {name}" |
*
* @param {Settings_WelcomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_welcome = /** @type {((inputs: Settings_WelcomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_WelcomeInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_welcome(inputs)
});
export { settings_welcome as "settings.welcome" }